<section class="hero-v2026" [class.hero-v2026--dark]="variant === 'dark'">
  <div class="container">
    <div class="hero-v2026__grid">
      <div class="hero-v2026__copy">
        @if (eyebrow) {
          <span class="hero-v2026__eyebrow">{{ eyebrow }}</span>
        }
        @if (headingLevel === 'h1') {
          <h1 class="hero-v2026__title">{{ heading }} @if (highlight) {<em>{{ highlight }}</em>}</h1>
        } @else {
          <p class="hero-v2026__title" role="heading" aria-level="2">{{ heading }} @if (highlight) {<em>{{ highlight }}</em>}</p>
        }
        @if (lede) {
          <p class="hero-v2026__lede">{{ lede }}</p>
        }
        <div class="hero-v2026__actions">
          <ng-content></ng-content>
        </div>
      </div>
      <div class="hero-v2026__aside">
        <ng-content select="[aside]"></ng-content>
      </div>
    </div>
  </div>
</section>
